module.exports = __webpack_public_path__ + "static/img/Landing Page_Banner sin botón_Planificaciones@4x.4c2fa577.png";